import { StyleSheet, Text, View } from '@react-pdf/renderer';

interface HeaderProps {
  headers: Record<string, any>;
  fixed?: boolean;
}

const Header = ({ headers, fixed = false }: HeaderProps) => {
  return (
    <View style={styles.headerRow} fixed={fixed}>
      {Object.entries(headers).map(([key, value]: [string, any]) => (
        <Text key={key} style={styles.headerCell}>
          {typeof value === 'string' ? value : value?.displayName || key}
        </Text>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  headerRow: {
    flexDirection: 'row',
    width: '100%',
    backgroundColor: '#40ADE2',
    minHeight: 25,
    alignItems: 'center',
  },
  headerCell: {
    flex: 1,
    padding: 4,
    textAlign: 'left',
    fontSize: 9,
    color: '#FFFFFF',
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
});

export default Header;
